import React from "react";
import bits_img from "./images/BITS.png";
import "bootstrap/dist/css/bootstrap.min.css";
import "./education.css";

const Education = () => {
  return (
    <div className="education" id="education">
      <h1>Education</h1>
      <hr></hr>
      <div className="row">
        <div className="col-md-4">
          <img src={bits_img} alt="BITS Logo"></img>
          <h3>BITS Pilani</h3>
          <h4>July 2016 - May 2021</h4>
        </div>
        <div className="col-md-8 content">
          <h2>Integrated Dual Degree (5-Year Course)</h2>
          <h4>
            <b>B.E. in Electrical and Electronics Engineering</b>
          </h4>
          <h4><b>M.Sc. in Economics</b></h4>
          <div className="brief">
            <p>
              Studying at BITS Pilani was an exceptional environment for comprehensive personal and professional development. The zero-attendance policy fostered self-directed learning, enabling me to explore diverse interests and chart my own learning path.
            </p>
            <p>
              <b>Key Highlights:</b>
            </p>
            <ul style={{marginLeft: "20px", marginTop: "10px"}}>
              <li>Built a strong foundation in Data Science through self-study, online courses, and collaborative research projects with faculty mentors</li>
              <li>Secured multiple internships in data science roles, progressively building hands-on experience in ML and analytics</li>
              <li>Completed coursework in economics that enhanced my business acumen and analytical thinking</li>
              <li>Participated in hackathons and competitive programming, developing problem-solving skills</li>
              <li>Developed strong fundamentals in electrical engineering, complementing my analytical capabilities</li>
            </ul>
          </div>
        </div>
      </div>
      <hr></hr>
    </div>
  );
};

export default Education;
